.statGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  width: 100%;
  max-width: 1100px;
  margin-top: 1.5rem;
}

@media (max-width: 880px) {
  .statGrid {
    grid-template-columns: repeat(2, 1fr);
    gap: 1rem;
  }
}

@media (max-width: 480px) {
  .statGrid {
    grid-template-columns: 1fr;
  }
}
